import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
//import { element } from '@angular/core/src/render3';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-balance-list',
  templateUrl: './balance-list.component.html',
  styleUrls: ['./balance-list.component.css']
})
export class BalanceListComponent implements OnInit {

  public menu_item_id = '54';

  private dp = [];
  displayedColumns = ['choose', 'acct_number', 'name', 'creditor_debtor', 'baseline_amount'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  type_list = [];
  // [{ 'acct_type': 'customer', 'acct_type_name_en': 'Customers', 'acct_type_name': 'العملاء', 
  //   'acct_type_no': '1', 'main_acct_no': '103' },
  //   { 'acct_type': 'supplier', 'acct_type_name_en': 'Supplierx', 'acct_type_name': 'الموردين', 'acct_type_no': '4', 
  //     'main_acct_no': '401' },
  //   { 'acct_type': 'bank_account', 'acct_type_name_en': 'Bank Accounts', 'acct_type_name': 'البنوك', 
  //   'acct_type_no': '1', 'main_acct_no': '102' }];

  status_list = [{ 'status_en': 'all', 'status_ar': 'الكل' },
  { 'status_en': 'not_entered', 'status_ar': 'لم يتم الإدخال' },
  { 'status_en': 'entered', 'status_ar': 'تم الإدخال' }];

  /*cd_list = [{ 'cd_name_en': 'creditor', 'cd_name_ar': 'دائن' },
  { 'cd_name_en': 'debtor', 'cd_name_ar': 'مدين' }];*/

  model = { 'acct_type': '', 'base_date': new Date(), 'status': 'all', 'acct_number': '' };

  Success_Msg; Error_Msg; Entered; Not_Entered; Acct_Type_Msg;
  Creditor; Debtor; Customers; Suppliers; Bank_Accts; All;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    // translate.get('All').subscribe((res: string) => {
    //   this.All = res;
    // });
    // this.status_list['0']['status_ar'] = this.All;

    // translate.get('Entered').subscribe((res: string) => {
    //   this.Entered = res;
    // });
    // this.status_list['2']['status_ar'] = this.Entered;

    // translate.get('Not_Entered').subscribe((res: string) => {
    //   this.Not_Entered = res;
    // });
    // this.status_list['1']['status_ar'] = this.Not_Entered;

    translate.get('Acct_Type_Msg').subscribe((res: string) => {
      this.Acct_Type_Msg = res;
    });

    translate.get('Creditor').subscribe((res: string) => {
      this.Creditor = res;
    });

    translate.get('Debtor').subscribe((res: string) => {
      this.Debtor = res;
    });

    // translate.get('Customers').subscribe((res: string) => {
    //   this.Customers = res;
    // });
    // this.type_list['0']['acct_type_name'] = this.Customers;

    // translate.get('Suppliers').subscribe((res: string) => {
    //   this.Suppliers = res;
    // });
    // this.type_list['1']['acct_type_name'] = this.Suppliers;

    // translate.get('Bank_Accts').subscribe((res: string) => {
    //   this.Bank_Accts = res;
    // });
    // this.type_list['2']['acct_type_name'] = this.Bank_Accts;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });
  }

  ngOnInit() {
    // get root level
    let parent_acct = "0";
    let obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: false, only_leaf: false };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.type_list = data.data['list'];
        this.type_list.unshift({ 'acct_number': '', 'sub_acct_name': 'الكل', 'sub_acct_name_en': 'All' })
        // console.log(this.type_list);
      });

    // let query = this.queryList.all_subAcct + " AND `parent_acct` = '0'";
    // let obj = { cmd: 'getList', query: query };

    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     this.type_list = data.data['list'];

    //     console.log(this.type_list);

    // (data.data['list']).forEach(element => {
    //   if (element.acct_type_no == '2') {
    //     element.acct_type = 'fixed_asset';
    //     element.main_acct_no = '201';
    //   }
    //   else {
    //     element.acct_type = 'sub_acct';
    //     element.main_acct_no = '';
    //   } 

    //   // if (this.applicationConstants.user_lang == 'en')
    //   //   element.acct_type_name = element.acct_type_name_en;
    //   this.type_list.push(element);
    // });
    // });

    let base_date = this.model['base_date'].getFullYear() + '-01-01';
    this.model['base_date'] = new Date(base_date);
  }

  ///////////////////////////// SEARCH /////////////////////////////

  search() {

    this.dp = [];

    // if (this.model['acct_number'] == '')
    //   alert(this.Acct_Type_Msg);

    // get leaf income accts
    let parent_acct = this.model['acct_number'];
    let status = 'all';

    let base_date = this.model['base_date'].getFullYear() + "-" +
      (this.model['base_date'].getMonth() + 1) + "-" + this.model['base_date'].getDate() + " 00:00:00";

    if (this.model['status'] == 'entered')
      status = 'entered';
    else if (this.model['status'] == 'not_entered')
      status = 'not_entered';
      
    let obj = {
      cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true,
      check_cc: true, get_baseline: true, status: status, base_date: base_date
    };

    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
        console.log(this.dp);
      });


    // else {
    //   // let table_name = "`" + this.model['acct_type'] + "`";
    //   let condition = "";
    //   let condition1 = "";
    //   // let field_name = "";

    //   let base_date = this.model['base_date'].getFullYear() + "-" +
    //     (this.model['base_date'].getMonth() + 1) + "-" + this.model['base_date'].getDate() + " 00:00:00";

    //   condition += " AND `acct_base`.`base_date` = '" + base_date + "'";

    //   // this.type_list.forEach(element => {
    //   //   if (element.acct_type == this.model['acct_type'])
    //   //     this.model['acct_type_no'] = element.acct_type_no;
    //   // });
    //   condition1 += " AND `sub_acct`.`acct_type_no` = '" + this.model['acct_type_no'] +
    //     "' AND `is_leaf` = '1' AND `is_cc` = '1'";

    // field_name = table_name + ".`acct_number`, ";

    // if (this.model['acct_type'] == 'customer') 
    //   field_name += table_name + ".`customer_id`, " + table_name + ".`customer_name` AS 'name', " + table_name + 
    //     ".`customer_name_en` AS 'name_en', '103' AS 'main_acct_no', ";

    // else if (this.model['acct_type'] == 'supplier') 
    //   field_name += table_name + ".`supplier_id`, " + table_name + ".`supplier_name` AS 'name', " + table_name + 
    //     ".`supplier_name_en` AS 'name_en', '401' AS 'main_acct_no', ";

    // else if (this.model['acct_type'] == 'bank_account') 
    //   field_name += table_name + ".`account_id`, " + table_name + ".`account_name` AS 'name', " + table_name + 
    //     ".`account_name_en` AS 'name_en', '102' AS 'main_acct_no', ";

    // else if (this.model['acct_type'] == 'fixed_asset')
    //   field_name += table_name + ".`asset_id`, " + table_name + ".`asset_name` AS 'name', " + table_name + 
    //     ".`asset_name_en` AS 'name_en', '201' AS 'main_acct_no', ";

    // else {
    //   field_name += table_name + ".`sub_acct_id`, " + table_name + ".`sub_acct_name` AS 'name', " + table_name + 
    //     ".`sub_acct_name_en` AS 'name_en', " + table_name + ".`main_acct_no`,";
    // }


    // let query = "SELECT `sub_acct`.`sub_acct_id`, `sub_acct`.`acct_number`, `sub_acct`.`sub_acct_name` AS 'name', " +
    //   "`sub_acct`.`sub_acct_name_en` AS 'name_en', `sub_acct`.`acct_type_no`, `sub_acct`.`main_acct_no`, " +
    //   "`sub_acct`.`acct_number` AS 'balance_id', `acct_base`.`baseline_id`, `acct_base`.`baseline_amount` " +
    //   "FROM `sub_acct`, `acct_base` WHERE `sub_acct`.`status` != '0'" + condition1 +
    //   " AND `sub_acct`.`acct_number` = `acct_base`.`acct_number`" + condition;

    /////////////////////////////  ENTERED /////////////////////////////

    // if (this.model['status'] == 'entered') {

    //   query = "SELECT `sub_acct`.`sub_acct_id`, `sub_acct`.`acct_number`, `sub_acct`.`sub_acct_name` AS 'name', " + 
    //     "`sub_acct`.`sub_acct_name_en` AS 'name_en', `sub_acct`.`main_acct_no`, `sub_acct`.`acct_number` AS 'balance_id', " +
    //     "`acct_base`.`baseline_id`, `acct_base`.`baseline_amount` FROM `sub_acct`, `acct_base` WHERE " +
    //     "`sub_acct`.`status` != '0'" + condition1 + " AND `sub_acct`.`acct_number` = `acct_base`.`acct_number`" + 
    //     condition;

    // query = "SELECT " + field_name + "`acct_base`.`baseline_id`, `acct_base`.`baseline_amount`, " + table_name + 
    //     ".`acct_number` AS 'balance_id' FROM `acct_base`, " + table_name + " WHERE " + table_name + 
    //     ".`status` != '0' AND " + table_name + ".`acct_number` = `acct_base`.`acct_number`" + condition;
    // else {
    //   if (acct_type_no != '2') {
    //     query = "SELECT `sub_acct`.`sub_acct_id`, `sub_acct`.`acct_number`, `sub_acct`.`sub_acct_name` AS 'name', `baseline_id`, `sub_acct`.`main_acct_no`," +
    //       "`acct_base`.`baseline_amount`, `sub_acct`.`acct_number` AS 'balance_id' FROM `sub_acct`, `acct_base` WHERE `sub_acct`.`status`" +
    //       " = '1' AND `sub_acct`.`acct_number` = `acct_base`.`acct_number`" + condition;
    //   }
    //   else {
    //     query = "SELECT `fixed_asset`.`asset_id`, `fixed_asset`.`acct_number`, `fixed_asset`.`asset_name` AS 'name', `baseline_id`, '201' AS 'main_acct_no'," +
    //       "`acct_base`.`baseline_amount`, `fixed_asset`.`acct_number` AS 'balance_id' FROM `fixed_asset`, `acct_base` WHERE `fixed_asset`.`status`" +
    //       " = '1' AND `fixed_asset`.`acct_number` = `acct_base`.`acct_number`" + condition;
    //   }
    // }
    // }

    ///////////////////////////// NOT ENTERED /////////////////////////////

    // else if (this.model['status'] == 'not_entered') {

    //   query = "SELECT `sub_acct`.`sub_acct_id`, `sub_acct`.`acct_number`, `sub_acct`.`sub_acct_name` AS 'name', " + 
    //     "`sub_acct`.`sub_acct_name_en` AS 'name_en', `sub_acct`.`main_acct_no`, " +
    //     "`sub_acct`.`acct_number` AS 'balance_id', '' AS 'baseline_amount' FROM `sub_acct` WHERE " +
    //     "`sub_acct`.`status` != '0'" + condition1 + " AND NOT EXISTS (SELECT `acct_base`.`acct_number` FROM `acct_base` WHERE " +
    //     "`sub_acct`.`acct_number` = `acct_base`.`acct_number`" + condition + ")";

    // if (this.model['acct_type'] == 'customer') {
    //   query = "SELECT `customer`.`customer_id`, `customer`.`customer_no` AS 'acct_number', `customer`.`customer_name` AS 'name'," +
    //     " '' AS 'baseline_amount', `customer`.`customer_no` AS 'balance_id' FROM `customer` WHERE `customer`.`status` = '1' AND " +
    //     "NOT EXISTS (SELECT `customer_base`.`customer_no` FROM `customer_base` WHERE `customer`." +
    //     "`customer_no` = `customer_base`.`customer_no`" + condition + ")";
    // }
    // else if (this.model['acct_type'] == 'supplier') {
    //   query = "SELECT `supplier`.`supplier_id`, `supplier`.`supplier_no` AS 'acct_number', `supplier`.`supplier_name` AS 'name'," +
    //     " '' AS 'baseline_amount', `supplier`.`supplier_no` AS 'balance_id' FROM `supplier` WHERE `supplier`.`status` = '1' AND " +
    //     "NOT EXISTS (SELECT `supplier_base`.`supplier_no` FROM `supplier_base` WHERE `supplier`." +
    //     "`supplier_no` = `supplier_base`.`supplier_no`" + condition + ")";
    // }
    // else if (this.model['acct_type'] == 'bank_account') {
    //   query = "SELECT `bank_account`.`account_id`, `bank_account`.`acct_number`, `bank_account`.`account_name` AS 'name'," +
    //     " '' AS 'baseline_amount', `bank_account`.`acct_number` AS 'balance_id' FROM `bank_account` WHERE `bank_account`.`status` = '1' AND " +
    //     "NOT EXISTS (SELECT `bank_base`.`acct_number` FROM `bank_base` WHERE `bank_account`." +
    //     "`acct_number` = `bank_base`.`acct_number`" + condition + ")";
    // }
    // else {
    //   let acct_type_no = '';
    //   this.type_list.forEach(element => {
    //     if (element.acct_type_name_en == this.model['acct_type'])
    //       acct_type_no = element.acct_type_no;
    //   });
    //   this.model['acct_type_no'] = acct_type_no;
    //   condition += " AND `acct_base`.`acct_type_no` = '" + acct_type_no + "'";
    //   if (acct_type_no != '2') {
    //     query = "SELECT `sub_acct`.`sub_acct_id`, `sub_acct`.`acct_number`, `sub_acct`.`sub_acct_name` AS 'name', `sub_acct`.`main_acct_no`," +
    //       " '' AS 'baseline_amount', `sub_acct`.`acct_number` AS 'balance_id' FROM `sub_acct` WHERE `sub_acct`.`status` = '1' " +
    //       "AND `sub_acct`.`acct_type_no` = '" + acct_type_no + "' AND " +
    //       "NOT EXISTS (SELECT `acct_base`.`acct_number` FROM `acct_base` WHERE `sub_acct`." +
    //       "`acct_number` = `acct_base`.`acct_number`" + condition + ")";

    //   }
    //   else {
    //     query = "SELECT `fixed_asset`.`asset_id`, `fixed_asset`.`acct_number`, `fixed_asset`.`asset_name` AS 'name', '201' AS 'main_acct_no'," +
    //       " '' AS 'baseline_amount', `fixed_asset`.`acct_number` AS 'balance_id' FROM `fixed_asset` WHERE `fixed_asset`.`status` = '1' AND " +
    //       "NOT EXISTS (SELECT `acct_base`.`acct_number` FROM `acct_base` WHERE `fixed_asset`." +
    //       "`acct_number` = `acct_base`.`acct_number`" + condition + ")";

    //   }
    // }
    // }

    ///////////////////////////// ALL /////////////////////////////

    // else {

    //   query = "(SELECT `sub_acct`.`sub_acct_id`, `sub_acct`.`acct_number`, `sub_acct`.`sub_acct_name` AS 'name', " + 
    //     "`sub_acct`.`sub_acct_name_en` AS 'name_en', `sub_acct`.`main_acct_no`, `sub_acct`.`acct_number` AS 'balance_id', " +
    //     "`acct_base`.`baseline_id`, `acct_base`.`baseline_amount` FROM `sub_acct`, `acct_base` WHERE " +
    //     "`sub_acct`.`status` != '0'" + condition1 + " AND `sub_acct`.`acct_number` = `acct_base`.`acct_number`" + condition + ")" +
    //     "UNION (SELECT `sub_acct`.`sub_acct_id`, `sub_acct`.`acct_number`, `sub_acct`.`sub_acct_name` AS 'name', " + 
    //     "`sub_acct`.`sub_acct_name_en` AS 'name_en', `sub_acct`.`main_acct_no`, `sub_acct`.`acct_number` AS 'balance_id', " +
    //     "'' AS 'baseline_id','' AS 'baseline_amount' FROM `sub_acct` WHERE `sub_acct`.`status` != '0'" + condition1 +
    //     " AND NOT EXISTS (SELECT `acct_base`.`acct_number` FROM `acct_base` WHERE " +
    //     "`sub_acct`.`acct_number` = `acct_base`.`acct_number`" + condition + "))";

    // if (this.model['acct_type'] == 'customer') {
    //   query = "(SELECT `customer`.`customer_id`, `customer`.`customer_no` AS 'acct_number', `customer`.`customer_name` AS 'name', `baseline_id`," +
    //     " `customer_base`.`baseline_amount`, `customer`.`customer_no` AS 'balance_id'  FROM `customer_base`, `customer` WHERE `customer`.`status` " +
    //     "= '1' AND `customer`.`customer_no` = `customer_base`.`customer_no`" + condition + ")" +
    //     "UNION (SELECT `customer`.`customer_id`, `customer`.`customer_no` AS 'acct_number', `customer`.`customer_name` AS 'name', '' AS 'baseline_id'," +
    //     " '' AS 'baseline_amount', `customer`.`customer_no` AS 'balance_id'  FROM `customer` WHERE `customer`.`status` = '1' AND " +
    //     "NOT EXISTS (SELECT `customer_base`.`customer_no` FROM `customer_base` WHERE `customer`." +
    //     "`customer_no` = `customer_base`.`customer_no`" + condition + "))";
    // }
    // else if (this.model['acct_type'] == 'supplier') {
    //   query = "(SELECT `supplier`.`supplier_id`, `supplier`.`supplier_no` AS 'acct_number', `supplier`.`supplier_name` AS 'name', `baseline_id`," +
    //     " `supplier_base`.`baseline_amount`, `supplier`.`supplier_no` AS 'balance_id' FROM `supplier_base`, `supplier` WHERE `supplier`.`status`" +
    //     " = '1' AND `supplier`.`supplier_no` = `supplier_base`.`supplier_no`" + condition + ")" +
    //     "UNION (SELECT `supplier`.`supplier_id`, `supplier`.`supplier_no` AS 'acct_number', `supplier`.`supplier_name` AS 'name', '' AS 'baseline_id'," +
    //     " '' AS 'baseline_amount', `supplier`.`supplier_no` AS 'balance_id' FROM `supplier` WHERE `supplier`.`status` = '1' AND " +
    //     "NOT EXISTS (SELECT `supplier_base`.`supplier_no` FROM `supplier_base` WHERE `supplier`." +
    //     "`supplier_no` = `supplier_base`.`supplier_no`" + condition + "))";
    // }
    // else if (this.model['acct_type'] == 'bank_account') {
    //   query = "(SELECT `bank_account`.`account_id`, `bank_account`.`acct_number`, `bank_account`.`account_name` AS 'name', `baseline_id`," +
    //     " `bank_base`.`baseline_amount`, `bank_account`.`acct_number` AS 'balance_id' FROM `bank_base`, `bank_account` WHERE `bank_account`.`status`" +
    //     " = '1' AND `bank_account`.`acct_number` = `bank_base`.`acct_number`" + condition + ")" +
    //     "UNION (SELECT `bank_account`.`account_id`, `bank_account`.`acct_number`, `bank_account`.`account_name` AS 'name', '' AS 'baseline_id'," +
    //     " '' AS 'baseline_amount', `bank_account`.`acct_number` AS 'balance_id' FROM `bank_account` WHERE `bank_account`.`status` = '1' AND " +
    //     "NOT EXISTS (SELECT `bank_base`.`acct_number` FROM `bank_base` WHERE `bank_account`." +
    //     "`acct_number` = `bank_base`.`acct_number`" + condition + "))";
    // }
    // else {
    //   let acct_type_no = '';
    //   this.type_list.forEach(element => {
    //     if (element.acct_type_name_en == this.model['acct_type'])
    //       acct_type_no = element.acct_type_no;
    //   });
    //   this.model['acct_type_no'] = acct_type_no;
    //   condition += " AND `acct_base`.`acct_type_no` = '" + acct_type_no + "'";
    //   if (acct_type_no != '2') {
    //     query = "(SELECT `sub_acct`.`sub_acct_id`, `sub_acct`.`acct_number`, `sub_acct`.`sub_acct_name` AS 'name', `baseline_id`, `sub_acct`.`main_acct_no`," +
    //       "`acct_base`.`baseline_amount`, `sub_acct`.`acct_number` AS 'balance_id' FROM `sub_acct`, `acct_base` WHERE `sub_acct`.`status`" +
    //       " = '1' AND `sub_acct`.`acct_number` = `acct_base`.`acct_number`" + condition + ")" +
    //       "UNION (SELECT `sub_acct`.`sub_acct_id`, `sub_acct`.`acct_number`, `sub_acct`.`sub_acct_name` AS 'name', '' AS 'baseline_id', '' AS 'main_acct_no'," +
    //       " '' AS 'baseline_amount', `sub_acct`.`acct_number` AS 'balance_id' FROM `sub_acct` WHERE `sub_acct`.`status` = '1' " +
    //       "AND `sub_acct`.`acct_type_no` = '" + acct_type_no + "' AND " +
    //       "NOT EXISTS (SELECT `acct_base`.`acct_number` FROM `acct_base` WHERE `sub_acct`." +
    //       "`acct_number` = `acct_base`.`acct_number`" + condition + "))";
    //   }
    //   else {
    //     query = "(SELECT `fixed_asset`.`asset_id`, `fixed_asset`.`acct_number`, `fixed_asset`.`asset_name` AS 'name', `baseline_id`, '201' AS 'main_acct_no'," +
    //       "`acct_base`.`baseline_amount`, `fixed_asset`.`acct_number` AS 'balance_id' FROM `fixed_asset`, `acct_base` WHERE `fixed_asset`.`status`" +
    //       " = '1' AND `fixed_asset`.`acct_number` = `acct_base`.`acct_number`" + condition + ")" +
    //       "UNION (SELECT `fixed_asset`.`asset_id`, `fixed_asset`.`acct_number`, `fixed_asset`.`asset_name` AS 'name', '' AS 'baseline_id', '' AS 'main_acct_no'," +
    //       " '' AS 'baseline_amount', `fixed_asset`.`acct_number` AS 'balance_id' FROM `fixed_asset` WHERE `fixed_asset`.`status` = '1' AND " +
    //       "NOT EXISTS (SELECT `acct_base`.`acct_number` FROM `acct_base` WHERE `fixed_asset`." +
    //       "`acct_number` = `acct_base`.`acct_number`" + condition + "))";
    //   }
    // }
    // }

    //   let obj = { cmd: 'getList', query: query };
    //   this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //     .subscribe(data => {
    //       this.applicationConstants.appComp.hideBusyCursor();

    //       this.dp = data.data['list'];
    //       this.dataSource = new MatTableDataSource(this.dp);
    //       this.dataSource.sort = this.sort;
    //       this.getCreditorDebtor();
    //     });
    // }
  }

  ///////////////////////////// CHECK ALL /////////////////////////////

  choose_all() {
    let choose_all = document.getElementById('choose_all') as HTMLInputElement;
    if (choose_all.checked) {
      this.dp.forEach(element => {
        let choose = document.getElementById('choose_' + element.balance_id) as HTMLInputElement;
        choose.checked = true;
      });
    }
    else {
      this.dp.forEach(element => {
        let choose = document.getElementById('choose_' + element.balance_id) as HTMLInputElement;
        choose.checked = false;
      });
    }
  }

  ///////////////////////////// CHECK THE CHECKBOX /////////////////////////////

  check(row) {
    let choose = document.getElementById('choose_' + row.balance_id) as HTMLInputElement;
    choose.checked = true;
  }

  ///////////////////////////// SAVE /////////////////////////////

  save() {
    let base_date = this.model['base_date'].getFullYear() + "-" +
      (this.model['base_date'].getMonth() + 1) + "-" + this.model['base_date'].getDate() + " 00:00:00";

    let add_values = [];
    let obj;
    let update_values = [];
    let where = [];

    this.dp.forEach(element => {
      let choose = document.getElementById('choose_' + element.balance_id) as HTMLInputElement;
      if (choose.checked) {
        let baseline_amount = document.getElementById('baseline_amount_' + element.balance_id) as HTMLInputElement;
        //let baseline_amount1 = document.getElementById('baseline_amount1' + element.balance_id) as HTMLInputElement;
        let creditor_debtor = document.getElementById('creditor_debtor_' + element.balance_id) as HTMLInputElement;
        let baseline_id = document.getElementById('baseline_id_' + element.balance_id) as HTMLInputElement;

        let amount;
        if (creditor_debtor.value == 'creditor' && baseline_amount.value != '0')
          amount = '-' + baseline_amount.value;
        else if (creditor_debtor.value == 'debtor' && baseline_amount.value != '0')
          amount = baseline_amount.value;
        else if (baseline_amount.value == '0')
          amount = '0';

        // let values = [];
        // let obj;

        ///////////////////////////// ADD /////////////////////////////

        if (baseline_id.value == '') {

          add_values.push({
            'table_name': 'acct_base', 'baseline_id': '0', 'base_date': base_date, 'main_acct_no': element.main_acct_no,
            'acct_type_no': this.model['acct_type_no'], 'acct_number': element.acct_number,
            'baseline_amount': amount, 'comment': ''
          });

          // if (this.model['acct_type'] == 'customer') {
          //   add_values.push({
          //     'table_name': 'customer_base', 'baseline_id': '0', 'customer_id': element.customer_id, 'base_date': base_date,
          //     'customer_no': element.acct_number, 'baseline_amount': amount, 'comment': ''
          //   });
          // }
          // else if (this.model['acct_type'] == 'supplier') {
          //   add_values.push({
          //     'table_name': 'supplier_base', 'baseline_id': '0', 'supplier_id': element.supplier_id, 'base_date': base_date,
          //     'supplier_no': element.acct_number, 'baseline_amount': amount, 'comment': ''
          //   });
          // }
          // else if (this.model['acct_type'] == 'bank_account') {
          //   add_values.push({
          //     'table_name': 'bank_base', 'baseline_id': '0', 'account_id': element.account_id, 'base_date': base_date,
          //     'acct_number': element.acct_number, 'baseline_amount': amount, 'comment': ''
          //   });
          // }
          // else {
          //   add_values.push({
          //     'table_name': 'acct_base', 'baseline_id': '0', 'base_date': base_date, 'main_acct_no': element.main_acct_no,
          //     'acct_type_no': this.model['acct_type_no'], 'acct_number': element.acct_number,
          //     'baseline_amount': amount, 'comment': ''
          //   });
          // }
          // obj = { cmd: 'add', values: values };
        }


        ///////////////////////////// UPDATE /////////////////////////////

        else {
          update_values.push({ 'table_name': 'acct_base', 'baseline_amount': amount });
          where.push({ 'baseline_id': element.baseline_id });

          // if (this.model['acct_type'] == 'customer') {
          //   update_values.push({ 'table_name': 'customer_base', 'baseline_amount': amount });
          // }
          // else if (this.model['acct_type'] == 'supplier') {
          //   update_values.push({ 'table_name': 'supplier_base', 'baseline_amount': amount });
          // }
          // else if (this.model['acct_type'] == 'bank_account') {
          //   update_values.push({ 'table_name': 'bank_base', 'baseline_amount': amount });
          // }
          // else {
          //   update_values.push({ 'table_name': 'acct_base', 'baseline_amount': amount });
          // }

          // obj = { cmd: 'update', values: values, where: where };
        }

        /////////////////////////////////////////////////////////////////////////

      }
    });
    //console.log(add_values);
    if (add_values.length > 0) {
      obj = { cmd: 'add', values: add_values };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            //console.log(data.status['type']);
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
    //console.log(update_values);
    if (update_values.length > 0) {
      obj = { cmd: 'update', values: update_values, where: where };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            //console.log(data.status['type']);
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

}
